import SendAsUrgentImage from '@shared/assets/images/v2/send-as-urgent.svg';
import { MBButton } from '@shared/components/MBButton';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { i18n } from '@shared/util/i18n';
import { Styles } from '../styles';

export interface MBUrgentModalContentProps {
  count: number;
  onClose(): void;
  onRemoveSendAsUrgent(): void;
}

export function MBUrgentModalContent({
  count,
  onClose,
  onRemoveSendAsUrgent,
}: MBUrgentModalContentProps) {
  return (
    <View>
      <MBImage style={Styles.urgentImage} source={SendAsUrgentImage} />
      <View paddingBottom={2} />

      <Text align="center">
        <Text weight="bold">{i18n('chat.modal.urgent.message.start', { count })}</Text>
        {i18n('chat.modal.urgent.message.end')}
      </Text>
      <View paddingBottom={2} />

      <Text align="center" size="body2" inactive>
        <Text weight="bold" size="body2">
          {i18n('chat.modal.urgent.proTip.start')}
        </Text>
        {i18n('chat.modal.urgent.proTip.end')}
      </Text>
      <View paddingBottom={2} />

      <MBButton title={i18n('common.gotIt')} onPress={onClose} />

      {!!count && (
        <>
          <View paddingBottom={1} />
          <MBButton
            title={i18n('chat.modal.urgent.removeSendAsUrgent')}
            theme="outline"
            onPress={onRemoveSendAsUrgent}
          />
        </>
      )}
    </View>
  );
}
